import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'vacancy-talent-details',
  templateUrl: 'vacancy-talent-details.component.html',
  styleUrls: ['vacancy-talent-details.component.scss'],
})
export class VacancyTalentDetailsComponent implements OnInit {

  @Input() set matchDetails(vals) {
    this.data = vals.expectations;
    this.matchRed = {
      domainMatch: !vals.domainMatch && !(!this.data.domainMatch.vacancy || !this.data.domainMatch.vacancy.length),
      educationMatch: !vals.educationMatch && !(!this.data.educationMatch.vacancy.educationDegree && !this.data.educationMatch.vacancy.educationField),
      employmentTypeMatch: !vals.employmentTypeMatch && !(this.data.employmentTypeMatch.vacancy),
      languageMatch: false,
      relocationMatch: !vals.relocationMatch && !this.data.relocationMatch.vacancy === null,
      salaryMatch: !vals.salaryMatch && !(!this.data.salaryMatch.vacancy.amount && !this.data.salaryMatch.vacancy.amountTo),
      workPlaceMatch: !vals.workPlaceMatch && !(!this.data.workPlaceMatch.vacancy)
    }
  };
  data = null;
  matchRed = null;

  constructor() {
  }

  ngOnInit(): void {
  }

}
